import { createClient } from '@/lib/supabase/client';

export type SiteSettings = {
  store_name: string;
  store_tagline: string;
  contact_email: string;
  contact_phone: string;
  address: string;
  social_links: {
    facebook?: string;
    twitter?: string;
    instagram?: string;
    linkedin?: string;
  };
  footer_content: string;
  enable_wishlist: boolean;
  enable_reviews: boolean;
  min_order_value: number;
  low_stock_threshold: number;
  custom_css?: string;
  privacy_policy?: string;
  terms_conditions?: string;
};

// Default settings as fallback
export const defaultSettings: SiteSettings = {
  store_name: "Ocean Tent Global",
  store_tagline: "Premium Spirits, Wine, Beer & More",
  contact_email: "info@oceantentglobal.com",
  contact_phone: "+234 809 670 5949",
  address: "123 Market Street, Lagos, Nigeria",
  social_links: {
    facebook: "https://facebook.com/oceantentglobal",
    twitter: "https://twitter.com/oceantentglobal",
    instagram: "https://instagram.com/oceantentglobal",
    linkedin: "https://linkedin.com/company/oceantentglobal",
  },
  footer_content: "© 2025 Ocean Tent Global. All rights reserved.",
  enable_wishlist: true,
  enable_reviews: false,
  min_order_value: 5000,
  low_stock_threshold: 10,
  custom_css: "",
  privacy_policy: "",
  terms_conditions: "",
};

/**
 * Fetches site settings from the database
 * @returns Promise with site settings
 */
export async function fetchSiteSettings(): Promise<SiteSettings> {
  try {
    const supabase = createClient();
    
    const { data, error } = await supabase
      .from('site_settings')
      .select('*')
      .single();
    
    if (error) {
      console.error('Error fetching site settings:', error);
      return defaultSettings;
    }
    
    // Parse and normalize the data
    const settings: SiteSettings = {
      ...defaultSettings,
      ...data,
      // Ensure social_links is properly parsed
      social_links: data.social_links ? 
        (typeof data.social_links === 'string' ? 
          JSON.parse(data.social_links) : data.social_links) 
        : defaultSettings.social_links,
      // Ensure numeric fields are numbers
      min_order_value: typeof data.min_order_value === 'string' ? 
        parseInt(data.min_order_value) : (data.min_order_value || defaultSettings.min_order_value),
      low_stock_threshold: typeof data.low_stock_threshold === 'string' ? 
        parseInt(data.low_stock_threshold) : (data.low_stock_threshold || defaultSettings.low_stock_threshold),
    };
    
    return settings;
  } catch (error) {
    console.error('Unexpected error fetching site settings:', error);
    return defaultSettings;
  }
}
